import QRCode from 'qrcode';

/**
 * Sends a support email to the backend API.
 *
 * @param {Object} data - The support email details.
 * @param {string} data.email - Sender's email address.
 * @param {string} data.subject - Subject of the email.
 * @param {string} data.message - Body of the message.
 * @returns {Promise<Object>} - Response from the API.
 */
export const sendSupportAcknowledgementToUser = async (name, email, supportId) => {
  try {
    const response = await fetch('https://procreddb.myearth.id/api/email/send-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        to: email,
        subject: 'Support Request Received',
        html: `
          <p>Dear ${name},</p>
          <p>Thank you for contacting EarthID Support. We have received your request and will respond shortly.</p>
          <p><strong>Support ID:</strong> ${supportId}</p>
          <p>Best regards,<br/>EarthID Support Team</p>
        `
      })
    });

    const result = await response.json();
    if (!response.ok) throw new Error(result.message || 'Failed to send user acknowledgment email');
    return result;
  } catch (err) {
    console.error("User Support Email Error:", err);
    return null;
  }
};


export const sendSupportTicketToTeam = async (name, email, message, supportId) => {
  try {
    const response = await fetch('https://procreddb.myearth.id/api/email/send-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        to: 'support@myearth.id',
        subject: `New Support Request from ${name}`,
        html: `
          <p><strong>Name:</strong> ${name}</p>
          <p><strong>Email:</strong> ${email}</p>
          <p><strong>Message:</strong><br/>${message}</p>
          <p><strong>Support ID:</strong> ${supportId}</p>
        `
      })
    });

    const result = await response.json();
    if (!response.ok) throw new Error(result.message || 'Failed to send support ticket to team');
    return result;
  } catch (err) {
    console.error("Team Support Email Error:", err);
    return null;
  }
};



export const sendEmailWithQRCode = async (to, qrDataObj) => {
  try {
    const qrText = typeof qrDataObj === 'string' ? qrDataObj : JSON.stringify(qrDataObj);
    const qrBase64 = await QRCode.toDataURL(qrText); // base64 image

    const html = `
      <p>Hello,</p>
      <p>Your EarthID Wallet has been issued. Scan the QR code below using EarthID App:</p>
      <img src="cid:qr-code" alt="QR Code" />
      <p>Thanks,<br/>EarthID Team</p>
    `;

    const attachments = [
      {
        filename: 'EarthID-Wallet-qr.png',
        content: qrBase64.split(',')[1], // remove "data:image/png;base64,"
        encoding: 'base64',
        cid: 'qr-code'
      }
    ];

    const response = await fetch('https://procreddb.myearth.id/api/email/send-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        to,
        subject: 'EarthID Wallet QR Code',
        html,
        attachments
      })
    });

    const result = await response.json();
    if (!response.ok) throw new Error(result.message || 'Failed to send email');
    return result;
  } catch (err) {
    console.error("QR Email Send Error:", err);
    return null;
  }
};
